<template>
    <div class="p-col-12">
        <page-header title="forms.account.accountTitle"/>
        <form @submit.prevent="save">
            <card :header="$t('forms.user.card-title-information')" class="p-col-12">
                <CoffInputText v-model="form.name" label="forms.user.name" class="p-col-12 p-md-6 p-lg-4" :error="validation.name" />
                <CoffInputText v-model="form.userName" label="forms.user.userName" class="p-col-12 p-md-6 p-lg-4" :error="validation.userName" />
                <CoffInputPassword v-model="form.creatPassword" label="forms.user.password" class="p-col-12 p-md-6 p-lg-4" :error="validation.creatPassword" />
                <CoffInputPassword v-model="form.repeatedPassword" label="forms.user.repeatPassword" class="p-col-12 p-md-6 p-lg-4" :error="validation.repeatedPassword" />
                <coff-input-select v-model="form.typeUser" label="forms.user.typeUser" class="p-col-12 p-md-3 p-lg-3" :options="typesUser" option-value="id" :error="validation.typeUser"/>
                <CoffInputRadio v-model="form.active" @update="form.active = $event" :options="options" label="forms.user.isActive" class="p-col-6 p-md-6 p-lg-4" :error="validation.active"/>
            </card>
            <div class="p-col-12">
                <Button :label="$t('btn.save&continue')" class="p-button-success" style="float: right;"/>
            </div>
        </form>
    </div>
</template>

<script>

    import ValidationUtils from "@/utils/ValidationUtils";
    import UserBusiness from "@/business/UserBusiness";
    import ToastMessageBusiness from "@/business/ToastMessageBusiness";
    import EventBus from "@/commons/EventBus";
    import PageHeader from "@/components/page/PageHeader";
    import { TYPES_USER } from "@/constants/TypeUser.js";

    export default {
        name: "UserForm",
        components: {PageHeader},
        data(){
            return {
                typesUser: TYPES_USER,
                form: {},
                validation: {
                    name: false,
                    userName: false,
                    creatPassword: false,
                    repeatedPassword: false,
                    typeUser: false,
                    active: false,
                },
                options: [
                    {value: true, label: 'field.default.yes'},
                    {value: false, label: 'field.default.no'}
                ]
            }
        },
        async mounted(){
            const id = this.$route.params.id;
            if(id){
                EventBus.loadingPage(true);
                this.form =  {... await UserBusiness.getById(id)};
                delete this.validation.creatPassword;
                delete this.validation.repeatedPassword;
                EventBus.loadingPage(false);
            }
        },
        methods:{
            async save(){
                this.validation = ValidationUtils.basicValidation(this.validation, this.form);
                if(!this.validation.erros){
                    const response = await UserBusiness.save(this.form, this.form.id).catch((e) => ToastMessageBusiness.showError(e.message));
                    if(response){
                        this.form = response;
                        ToastMessageBusiness.showSuccess();
                    }
                }
            },
        }
    }
</script>

<style scoped>

</style>
